import StudentTermsAndConditions from './StudentTerms&Conditions';
export default StudentTermsAndConditions;
